export const documentType = {
  TOUS: process.env.REACT_APP_IMAGE_DOCUMENT_TYPE ?? 3,
  CONTRAT: process.env.REACT_APP_CONTRAT_DOCUMENT_TYPE ?? 2,
  DOCUMENT_TECHNIQUE:
    process.env.REACT_APP_DOCUMENT_TECHNIQUE_DOCUMENT_TYPE ?? 1,
};
